(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8375],{

/***/ 49707:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/pricing",
      function () {
        return __webpack_require__(46813);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 18495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_fa6__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70231);


const GradientCheckIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "gradient",
                    x1: "0%",
                    y1: "0%",
                    x2: "100%",
                    y2: "0%",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0%",
                            stopColor: "#a855f7"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "50%",
                            stopColor: "#6366f1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "100%",
                            stopColor: "#3b82f6"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa6__WEBPACK_IMPORTED_MODULE_1__/* .FaRegCircleCheck */ .ReY, {
                style: {
                    fill: "url(#gradient)",
                    width: "100%",
                    height: "100%"
                }
            })
        ]
    });
/* harmony default export */ __webpack_exports__["Z"] = (GradientCheckIcon);


/***/ }),

/***/ 26239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Pricing_ApiAddonPricingCard2; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/stripe.js
var stripe = __webpack_require__(42830);
// EXTERNAL MODULE: ./components/v2/Slider/CustomReactSlider.jsx
var CustomReactSlider = __webpack_require__(15662);
// EXTERNAL MODULE: ./utils/signature_owner.js
var signature_owner = __webpack_require__(10447);
// EXTERNAL MODULE: ./node_modules/react-loader-spinner/dist/esm/index.js + 42 modules
var esm = __webpack_require__(62194);
// EXTERNAL MODULE: ./components/v2/Cards/GradientCheckIcon.jsx
var GradientCheckIcon = __webpack_require__(18495);
;// CONCATENATED MODULE: ./components/v2/Slider/CustomBoloSlider2.jsx



const CustomBoloSlider2 = (param)=>{
    let { defaultValue =1000 , min =500 , max =5000 , marks =[
        {
            value: 500,
            label: "500"
        },
        {
            value: 1000,
            label: "1000"
        },
        {
            value: 2000,
            label: "2000"
        },
        {
            value: 5000,
            label: "5000"
        }
    ] , onChange , currentActiveMark =0  } = param;
    const [value, setValue] = (0,react.useState)(defaultValue);
    const [isDragging, setIsDragging] = (0,react.useState)(false);
    const sliderRef = (0,react.useRef)(null);
    const thumbRef = (0,react.useRef)(null);
    // Find the closest mark value to snap to
    const findClosestMark = (currentValue)=>{
        return marks.reduce((closest, mark)=>{
            return Math.abs(mark.value - currentValue) < Math.abs(closest - currentValue) ? mark.value : closest;
        }, marks[0].value);
    };
    // Convert pixel position to value
    const getValueFromPosition = (position)=>{
        if (!sliderRef.current) return min;
        const rect = sliderRef.current.getBoundingClientRect();
        const percentage = (position - rect.left) / rect.width;
        const rawValue = min + (max - min) * Math.max(0, Math.min(1, percentage));
        return Math.round(rawValue);
    };
    // Convert value to percentage for positioning
    const getPercentage = (value)=>{
        if (value === 200) {
            return (value + 80 - min) / (max - min) * 100;
        }
        return (value - min) / (max - min) * 100;
    };
    const handleMouseDown = (e)=>{
        setIsDragging(true);
        const newValue = getValueFromPosition(e.clientX);
        setValue(newValue);
        if (onChange) onChange(newValue);
    };
    const handleMouseMove = (e)=>{
        if (!isDragging) return;
        const newValue = getValueFromPosition(e.clientX);
        setValue(newValue);
        if (onChange) onChange(newValue);
    };
    const handleMouseUp = ()=>{
        if (!isDragging) return;
        setIsDragging(false);
        const snappedValue = findClosestMark(value);
        setValue(snappedValue);
        if (onChange) onChange(snappedValue);
    };
    (0,react.useEffect)(()=>{
        if (isDragging) {
            window.addEventListener("mousemove", handleMouseMove);
            window.addEventListener("mouseup", handleMouseUp);
        }
        return ()=>{
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [
        isDragging,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full py-8 select-none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: sliderRef,
            className: "relative w-full h-2 bg-slate-200 cursor-pointer",
            onMouseDown: handleMouseDown,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute h-2 bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 ",
                    style: {
                        width: "".concat(getPercentage(value), "%")
                    }
                }),
                marks.map((mark, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            left: "".concat(getPercentage(mark.value), "%")
                        },
                        className: "absolute",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute md:w-1 w-0.5 h-6 rounded-full   -translate-x-1/2 -translate-y-2 ".concat(mark.value <= value ? "bg-primary" : "bg-slate-400", " ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute text-xs -translate-x-1/2 mt-6 flex flex-col gap-1 items-center justify-center ".concat(mark.value <= value ? "text-primary font-bold" : "text-gray-600", " "),
                                children: mark.label
                            })
                        ]
                    }, mark.value)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: thumbRef,
                    className: "absolute w-6 h-6 bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 rounded-full border-[3px] border-white shadow-md cursor-pointer transform -translate-x-1/2 -translate-y-1/2 transition-transform duration-150 top-1/2 ",
                    style: {
                        left: "".concat(getPercentage(value), "%"),
                        transform: "translate(-50%, -50%) scale(".concat(isDragging ? 1.1 : 1, ")")
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var Slider_CustomBoloSlider2 = (CustomBoloSlider2);

// EXTERNAL MODULE: ./components/CLM/v3/Buttons.jsx
var Buttons = __webpack_require__(56475);
;// CONCATENATED MODULE: ./components/v2/Pricing/ApiAddonPricingCard2.jsx













const ApiAddonPricingCard2 = (param)=>{
    let { currentPage , title , subTitle , bgColor ="bg-white" , cardBorder  } = param;
    var _featureDataObject_includes_currentPage;
    const [priceLoading, setPriceLoading] = (0,react.useState)(false);
    const featureDataObject = (0,react.useMemo)(()=>{
        return {
            title: "BoloSign API",
            desc: "Automate your signature workflow by integrating our API into your systems.",
            includes: {
                api: [
                    "BoloSign Webhooks",
                    "BoloSign Embeddings"
                ],
                embedding: [
                    "BoloSign Webhooks",
                    "BoloSign API"
                ]
            },
            features: [
                "BoloSign API Access",
                "BoloSign Webhooks",
                "BoloSign Embeddings",
                "Customizable Branding",
                "Session Control",
                "Create PDFs",
                "Send PDFs for signature",
                "Fetch PDF status in your website",
                "Zapier Integration",
                "Pabbly Integration",
                "Make (Integromat) Integration",
                "And more..."
            ]
        };
    }, []);
    const envelopeCountAndPrice = [
        {
            count: 100,
            price: 40
        },
        {
            count: 200,
            price: 72
        },
        {
            count: 500,
            price: 180
        },
        {
            count: 1000,
            price: 360
        },
        {
            count: 2000,
            price: 720
        },
        {
            count: 3000,
            price: "Contact Sales"
        }
    ];
    const [apiPrice, setApiPrice] = (0,react.useState)(envelopeCountAndPrice[1].price);
    const [documentSliderCount, setDocumentSliderCount] = (0,react.useState)(envelopeCountAndPrice[1].count);
    //   const ownerPlanDetails = getOwnerPlanDetails();
    //   const currentPlanTier = ownerPlanDetails?.currentPlan?.tier;
    //   const isCurrentPlanActive = ownerPlanDetails.currentPlan?.isActive;
    const handleSliderChange = (newValue)=>{
        setDocumentSliderCount(newValue);
        const selectedPrice = envelopeCountAndPrice.find((item)=>item.count === newValue);
        if (selectedPrice) {
            setApiPrice(selectedPrice.price);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " flex flex-col gap-y-2 w-full lg:p-6 p-4 md:p-10 border-2 border-slate-200 rounded-3xl relative mb-20 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-4xl font-bold text-left",
                        children: title || featureDataObject.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base text-left text-gray-600 mt-4 ",
                        children: subTitle || featureDataObject.desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex md:gap-8 gap-2 mt-4 lg:flex-row flex-col",
                        children: (_featureDataObject_includes_currentPage = featureDataObject.includes[currentPage]) === null || _featureDataObject_includes_currentPage === void 0 ? void 0 : _featureDataObject_includes_currentPage.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base leading-[24px] font-semibold  mb-1",
                                        children: item
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "space-y-2 min-h-[100px]",
                    children: apiPrice === "Contact Sales" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-start items-center w-full min-h-[100px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-5xl font-bold text-black",
                            children: "Contact Sales"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-start items-end w-full h-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-6xl font-bold",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-4xl mr-1",
                                                children: "$"
                                            }),
                                            apiPrice
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-2xl ml-1",
                                        children: "/mo"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-left text-base text-gray-600",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-semibold text-gray-700",
                                        children: "$0.5"
                                    }),
                                    " for each document beyond",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-semibold text-gray-700 mx-1",
                                        children: documentSliderCount
                                    }),
                                    "limit."
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider_CustomBoloSlider2, {
                    defaultValue: documentSliderCount,
                    min: 100,
                    max: 3000,
                    marks: envelopeCountAndPrice.map((item)=>({
                            value: item.count,
                            label: "".concat(item.count)
                        })),
                    onChange: handleSliderChange,
                    currentActiveMark: 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full flex justify-start items-center gap-3 md:flex-row flex-col my-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* CLMButtonPrimary1 */.au, {
                        buttonText: apiPrice === "Contact Sales" ? "Contact Sales" : "Subscribe Now",
                        className: "w-full md:w-auto",
                        onClick: async ()=>{
                            if (apiPrice === "Contact Sales") {
                                window === null || window === void 0 ? void 0 : window.Intercom("showNewMessage");
                            } else {
                                setPriceLoading(true);
                                await (0,stripe.createAPITierSubscriptions)({
                                    documentsCount: documentSliderCount
                                });
                                setPriceLoading(false);
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* CLMSecondaryBorder */.kL, {
                        className: "w-full md:w-auto",
                        onClick: ()=>{
                            window.open("https://signature.boloforms.com/register?from=API_PAGE".concat((0,signature_owner/* createUTMQueryParams */.T0)({
                                from: "API_PAGE"
                            })), "_self");
                        },
                        buttonText: "Try Sandbox Testing for $0"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4",
                children: featureDataObject.features.map((feature, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-base leading-[24px] font-medium  ",
                                children: feature
                            })
                        ]
                    }, index))
            })
        ]
    });
};
/* harmony default export */ var Pricing_ApiAddonPricingCard2 = (ApiAddonPricingCard2);


/***/ }),

/***/ 46813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pricing; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/v2/CTA/CtaOne.jsx
var CtaOne = __webpack_require__(59183);
// EXTERNAL MODULE: ./components/v2/Cards/PricingCards.jsx
var PricingCards = __webpack_require__(33103);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./components/v2/MiniComponents/index.jsx
var MiniComponents = __webpack_require__(61325);
// EXTERNAL MODULE: ./components/v2/Slider/index.jsx
var Slider = __webpack_require__(24747);
// EXTERNAL MODULE: ./components/v2/FAQ/index.jsx
var FAQ = __webpack_require__(22288);
// EXTERNAL MODULE: ./components/v2/Subscribe/index.jsx
var Subscribe = __webpack_require__(18034);
// EXTERNAL MODULE: ./components/v2/Comparisons/PricingComparisons.jsx
var PricingComparisons = __webpack_require__(43590);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(43138);
// EXTERNAL MODULE: ./components/v2/Pricing/PricingTable.jsx
var PricingTable = __webpack_require__(61735);
// EXTERNAL MODULE: ./components/v2/SocialProof/index.jsx
var SocialProof = __webpack_require__(77633);
// EXTERNAL MODULE: ./utils/signature_owner.js
var signature_owner = __webpack_require__(10447);
// EXTERNAL MODULE: ./components/v2/Pricing/ApiAddonPricingCard.jsx
var ApiAddonPricingCard = __webpack_require__(8054);
// EXTERNAL MODULE: ./components/v2/Cards/FeatureImagePopup.jsx
var FeatureImagePopup = __webpack_require__(10459);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/components/motion/proxy.mjs + 243 modules
var proxy = __webpack_require__(17568);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(2261);
// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 26 modules
var modules = __webpack_require__(99304);
// EXTERNAL MODULE: ./components/v2/Buttons/index.jsx
var Buttons = __webpack_require__(46687);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./utils/mixpanel.js + 1 modules
var mixpanel = __webpack_require__(43110);
// EXTERNAL MODULE: ./utils/tracking/facebook.js + 16 modules
var facebook = __webpack_require__(91806);
// EXTERNAL MODULE: ./components/AppContext.js
var AppContext = __webpack_require__(2208);
// EXTERNAL MODULE: ./components/v2/google-ads/Buttons.jsx
var google_ads_Buttons = __webpack_require__(71631);
// EXTERNAL MODULE: ./components/CLM/v3/Buttons.jsx
var v3_Buttons = __webpack_require__(56475);
;// CONCATENATED MODULE: ./components/v2/Cards/PricingCard3.jsx
















const PricingCardV3 = (param)=>{
    let { title , description , price , priceDetail , pricingType , pricingTag , featuresIcon , featuresTitle , features , pricingLink , bgColor , quantityName , recommended , cardBorder =false , buttonText , buttonUrl , transparent =true , buttonSecondaryText , buttonSecondaryUrl , trialButtonText , trialButtonUrl , isAnnualBilling , owner , contactUs , setImagePopup , additionalSeatPrice , noCreditCard , setRegisterPopup , packagesCount , conditions ={
        navigateRegister: false,
        navigateCheckout: false
    } , setShowCalcomModal  } = param;
    var _context_globalData, _context_globalData_utmData;
    const context = (0,react.useContext)(AppContext/* default */.Z);
    const [quantity, setQuantity] = (0,react.useState)(1);
    const [is1DollarTrialCampaignState, setIs1DollarTrialCampaignState] = (0,react.useState)(false);
    const handleQuantity = (type)=>{
        if (type === "add") {
            setQuantity(quantity + 1);
        } else {
            if (quantity > 1) {
                setQuantity(quantity - 1);
            }
        }
    };
    const PRICE_IDS = {
        Freelancer: {
            monthly: "price_1OUqsgLiGbRu8waGk8eObdee",
            annually: "price_1Pm6c8LiGbRu8waGnOLvuz9X"
        },
        Team: {
            monthly: "price_1Prwz6LiGbRu8waGHZVC9vlT",
            annually: "price_1PryxwLiGbRu8waGJRAgEtfv"
        },
        "Growing Business": {
            monthly: "price_1PrwyWLiGbRu8waG4z6iibAA",
            annually: "price_1PryznLiGbRu8waGelr3LUcb"
        },
        API: {
            // no annually for api
            priceIdBase: "price_1PYojRLiGbRu8waGVLQYGY9Q",
            priceIdUsage: "price_1PYokyLiGbRu8waGlZU5MzpM"
        }
    };
    let createStripeSubscriptionAPI = async (title)=>{
        try {
            // let priceId;
            // const durationKey = isAnnualBilling ? "annually" : "monthly";
            // priceId = PRICE_IDS?.[title]?.[durationKey];
            // if (!priceId)
            //   window.location.href = `https://signature.boloforms.com/register?from=WEBSITE_PRICING_BUTTON`;
            // let quantity = title === "Freelancer" ? 1 : count;
            // let quantity = quantity;
            let { data  } = await axios/* default.post */.Z.post("".concat(constants.SIGNATURE_PAYMENTS_BASE_URL, "/createAPISubscriptionUS"), {
                priceId: PRICE_IDS[title].priceIdBase,
                meteredPriceId: PRICE_IDS[title].priceIdUsage,
                ownerEmail: owner === null || owner === void 0 ? void 0 : owner.email,
                cancelUrl: window.location.href,
                successUrl: "https://www.boloforms.com/thank-you?value=".concat(price * quantity, "&priceId=").concat(PRICE_IDS[title].priceIdBase, "&priceIdUsage=").concat(PRICE_IDS[title].priceIdUsage, "&qunatity=").concat(quantity, "&plan=").concat(title)
            });
            let { sessionUrl  } = data;
            // facebook tracking
            new facebook["default"]().trackInitiateCheckout(title, PRICE_IDS[title].priceIdBase, quantity, isAnnualBilling ? 12 * price * quantity : price * quantity);
            // mixpanel tracking
            new mixpanel["default"]().track("Billing", {
                billing_action: "billing_click_subscribe",
                plan: title,
                pack: quantity,
                planCycle: isAnnualBilling ? "Annually" : "Monthly",
                amount: isAnnualBilling ? 12 * price * quantity : price * quantity
            });
            new mixpanel["default"]().increment("billing_click_subscribe");
            window.open(sessionUrl, "_self");
        } catch (error) {
            console.error(error);
        }
    };
    let createStripeSubscription = async (title)=>{
        if (title === "API") {
            createStripeSubscriptionAPI(title);
            return;
        }
        try {
            var _PRICE_IDS_title;
            let priceId;
            const durationKey = isAnnualBilling ? "annually" : "monthly";
            priceId = PRICE_IDS === null || PRICE_IDS === void 0 ? void 0 : (_PRICE_IDS_title = PRICE_IDS[title]) === null || _PRICE_IDS_title === void 0 ? void 0 : _PRICE_IDS_title[durationKey];
            if (!priceId) window.location.href = "https://signature.boloforms.com/register?from=WEBSITE_PRICING_BUTTON".concat((0,signature_owner/* createUTMQueryParams */.T0)({
                from: "WEBSITE_PRICING_BUTTON"
            }));
            if (conditions === null || conditions === void 0 ? void 0 : conditions.navigateCheckout) {
                let checkoutUrl = (0,signature_owner/* createCheckoutURL */.OM)({
                    priceId: priceId,
                    quantity: quantity,
                    value: price,
                    product: title,
                    cycle: isAnnualBilling ? "annually" : "monthly"
                });
                window.open(checkoutUrl, "_self");
            } else {
                // let quantity = title === "Freelancer" ? 1 : count;
                // let quantity = quantity;
                let { data  } = await axios/* default.post */.Z.post("".concat(constants.SIGNATURE_PAYMENTS_BASE_URL, "/createStripeSubscriptionUS"), {
                    priceId: priceId,
                    quantity: quantity,
                    ownerEmail: owner === null || owner === void 0 ? void 0 : owner.email,
                    cancelUrl: window.location.href,
                    successUrl: "https://www.boloforms.com/thank-you?value=".concat(price * quantity, "&priceId=").concat(priceId, "&qunatity=").concat(quantity, "&plan=").concat(title)
                });
                let { sessionUrl  } = data;
                // facebook tracking
                new facebook["default"]().trackInitiateCheckout(title, priceId, quantity, isAnnualBilling ? 12 * price * quantity : price * quantity);
                // mixpanel tracking
                new mixpanel["default"]().track("Billing", {
                    billing_action: "billing_click_subscribe",
                    plan: title,
                    pack: quantity,
                    planCycle: isAnnualBilling ? "Annually" : "Monthly",
                    amount: isAnnualBilling ? 12 * price * quantity : price * quantity
                });
                new mixpanel["default"]().increment("billing_click_subscribe");
                window.open(sessionUrl, "_self");
            }
        } catch (error) {
            console.error(error);
        }
    };
    (0,react.useEffect)(()=>{
        var _context_globalData, _context_globalData_utmData;
        setIs1DollarTrialCampaignState((0,signature_owner/* is1DollarTrialCampaign */.Og)({
            utm_campaign: context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
        }));
    }, [
        context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full md:rounded-3xl rounded-xl  flex flex-col gap-10 justify-between items-center  bg-white border-[2px] border-slate-200 relative ".concat(recommended ? "" : ""),
            children: [
                recommended && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 right-0 w-1/2 md:h-12 h-9 bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 flex items-center justify-center md:rounded-bl-3xl md:rounded-tr-3xl rounded-tr-xl rounded-bl-xl text-white md:text-[18px] text-smfont-medium",
                    children: "Most Popular"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full space-y-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "border-b-2 border-b-slate-200 md:p-6 p-4 flex justify-start items-start flex-col min-h-[280px] ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-3xl font-bold",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[15px] text-left text-gray-600 mt-4 min-h-[60px] ",
                                    children: description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: typeof price === "number" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex justify-center items-end",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-5xl font-bold",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-3xl mr-1",
                                                                children: "$"
                                                            }),
                                                            title === "Growing Business" ? price + additionalSeatPrice * (quantity - 1) : price * quantity
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-xl",
                                                        children: packagesCount || "/mo"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-left text-base text-gray-600",
                                                children: pricingType === "One-time" ? "One-time" : pricingType === "mo" ? "Billed monthly" : "Billed Annually"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full flex flex-col gap-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base text-left min-h-[81px] font-semibold",
                                            children: price
                                        })
                                    })
                                }),
                                pricingTag && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-lg flex items-center justify-start gap-2 font-semibold mt-3 bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaSignature */.SV_, {
                                            className: "text-xl text-purple-500"
                                        }),
                                        typeof pricingTag == "number" ? "".concat(pricingTag * quantity, " Form Signatures/Mo") : "".concat(pricingTag, " Form Signatures")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full flex flex-col gap-4 text-left md:px-6 px-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-lg font-semibold",
                                    dangerouslySetInnerHTML: {
                                        __html: featuresTitle || "What's included?"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col gap-3",
                                    children: features.map((feature, index)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-start justify-start gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: " w-6 h-6 flex items-center justify-center shrink-0",
                                                    children: featuresIcon
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-base leading-[24px] font-medium hover:bg-gradient-to-r   ".concat((feature === null || feature === void 0 ? void 0 : feature.image) ? " underline underline-offset-[5px] decoration-dotted cursor-pointer decoration-gray-400 hover:decoration-primary hover:text-primary hover:from-purple-500  hover:via-indigo-500  hover:to-blue-500  hover:bg-clip-text  hover:text-transparent " : ""),
                                                    onClick: ()=>{
                                                        return (feature === null || feature === void 0 ? void 0 : feature.image) && setImagePopup(feature.image);
                                                    },
                                                    children: feature === null || feature === void 0 ? void 0 : feature.name
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full md:px-6 px-4 md:pb-6 pb-4",
                    children: [
                        buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_Buttons/* CLMButtonPrimary1 */.au, {
                            buttonText: price == 0 ? "Get Started" : buttonText,
                            onClick: ()=>title === "Enterprise" ? setShowCalcomModal(true) : buttonUrl ? window.open(buttonUrl, "_self") : createStripeSubscription(title),
                            className: "w-full "
                        }),
                        title === "Enterprise" && /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_Buttons/* CLMButtonSecondaryBorder */.AL, {
                            buttonText: "Contact Us",
                            buttonUrl: "tel:+14156496611",
                            className: "w-full mt-2"
                        }),
                        buttonSecondaryText && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_Buttons/* CLMSecondaryBorder */.kL, {
                                buttonText: buttonSecondaryText,
                                buttonUrl: "".concat(pricingLink)
                            })
                        }),
                        trialButtonText && price !== 0 && title !== "Enterprise" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-2",
                            children: is1DollarTrialCampaignState ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_Buttons/* CLMSecondaryBorder */.kL, {
                                btnText: "Start 7-days trial @1$",
                                className: "w-full"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_Buttons/* CLMSecondaryBorder */.kL, {
                                buttonText: trialButtonText,
                                className: "w-full",
                                onClick: ()=>{
                                    (conditions === null || conditions === void 0 ? void 0 : conditions.navigateRegister) ? window.open(trialButtonUrl, "_self") : setRegisterPopup(true);
                                }
                            })
                        }),
                        !is1DollarTrialCampaignState && noCreditCard && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-center text-sm text-gray-600 mt-2  ".concat(title === "Enterprise" && "overflow-hidden w-0 h-[20px]"),
                            children: "No credit card required"
                        }),
                        contactUs && /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_Buttons/* CLMButtonSecondaryBorder */.AL, {
                            buttonText: "Contact Us",
                            buttonUrl: "https://cal.com/boloforms/signature",
                            className: "w-full"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var PricingCard3 = (PricingCardV3);

// EXTERNAL MODULE: ./node_modules/swiper/swiper.css
var swiper = __webpack_require__(89087);
// EXTERNAL MODULE: ./node_modules/swiper/modules/controller.css
var controller = __webpack_require__(47287);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination.css
var pagination = __webpack_require__(86657);
// EXTERNAL MODULE: ./components/SignatureRegister/index.jsx + 11 modules
var SignatureRegister = __webpack_require__(71605);
// EXTERNAL MODULE: ./components/v2/Modal/CalComModal.jsx
var CalComModal = __webpack_require__(65421);
;// CONCATENATED MODULE: ./components/v2/Pricing/PricingTable2.jsx













const PricingTable2 = (param)=>{
    let { isMonthly , monthlyPricing , yearlyPricing  } = param;
    const [imagePopup, setImagePopup] = (0,react.useState)(null);
    const [registerPopup, setRegisterPopup] = (0,react.useState)(false);
    const [showCalcomModal, setShowCalcomModal] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative w-full pb-10 pt-8 md:px-10 px-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                breakpoints: {
                    0: {
                        slidesPerView: 1.2,
                        centeredSlides: true
                    },
                    640: {
                        slidesPerView: 2.2,
                        centeredSlides: true
                    },
                    1024: {
                        slidesPerView: 2.5,
                        centeredSlides: false
                    },
                    1120: {
                        slidesPerView: 3,
                        centeredSlides: false
                    },
                    1280: {
                        slidesPerView: 4,
                        centeredSlides: false
                    }
                },
                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 10,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                modules: [
                    modules/* Pagination */.tl
                ],
                className: "relative [mask:linear-gradient(90deg,transparent,#fff_5%,#fff_95%,transparent)] xxl:[mask:none] mx-auto max-w-[1600px]",
                initialSlide: 0,
                children: isMonthly ? monthlyPricing.map((pricingCard, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        className: "[height:auto_!important]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sm:px-1 pb-20 max-w-[min(400px,100%)] mx-auto h-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCard3, {
                                title: pricingCard.title,
                                description: pricingCard.description,
                                price: pricingCard.price,
                                pricingType: pricingCard.pricingType,
                                pricingTag: pricingCard.pricingTag,
                                featuresTitle: pricingCard.featuresTitle,
                                featuresIcon: pricingCard.featuresIcon,
                                features: pricingCard.features,
                                pricingLink: pricingCard.pricingLink,
                                bgColor: pricingCard.bgColor,
                                quantityName: pricingCard.quantityName,
                                recommended: pricingCard.recommended,
                                isAnnualBilling: false,
                                owner: "",
                                transparent: pricingCard.transparent ? true : false,
                                buttonText: pricingCard.buttonText || "Subscribe Now",
                                buttonUrl: pricingCard.buttonUrl,
                                trialButtonText: "Start 7-days free trial",
                                trialButtonUrl: (0,signature_owner/* createRegisterURL */.YV)({
                                    from: "PRICING_PAGE"
                                }),
                                conditions: {
                                    navigateRegister: true,
                                    navigateCheckout: true
                                },
                                noCreditCard: true,
                                setImagePopup: setImagePopup,
                                setShowCalcomModal: setShowCalcomModal,
                                additionalSeatPrice: pricingCard === null || pricingCard === void 0 ? void 0 : pricingCard.additionalSeatPrice,
                                setRegisterPopup: setRegisterPopup
                            }, index)
                        })
                    }, index);
                }) : yearlyPricing.map((pricingCard, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        className: "[height:auto_!important]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sm:px-1 pb-20 max-w-[min(400px,100%)] mx-auto h-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCard3, {
                                title: pricingCard.title,
                                description: pricingCard.description,
                                price: pricingCard.price,
                                pricingType: pricingCard.pricingType,
                                pricingTag: pricingCard.pricingTag,
                                featuresTitle: pricingCard.featuresTitle,
                                featuresIcon: pricingCard.featuresIcon,
                                features: pricingCard.features,
                                pricingLink: pricingCard.pricingLink,
                                bgColor: pricingCard.bgColor,
                                quantityName: pricingCard.quantityName,
                                recommended: pricingCard.recommended,
                                isAnnualBilling: true,
                                owner: "",
                                transparent: pricingCard.transparent ? true : false,
                                buttonText: pricingCard.buttonText || "Subscribe Now",
                                buttonUrl: pricingCard.buttonUrl,
                                trialButtonText: "Start 7-days free trial",
                                trialButtonUrl: (0,signature_owner/* createRegisterURL */.YV)({
                                    from: "PRICING_PAGE"
                                }),
                                conditions: {
                                    navigateRegister: true,
                                    navigateCheckout: true
                                },
                                noCreditCard: true,
                                setImagePopup: setImagePopup,
                                setShowCalcomModal: setShowCalcomModal,
                                additionalSeatPrice: pricingCard === null || pricingCard === void 0 ? void 0 : pricingCard.additionalSeatPrice,
                                setRegisterPopup: setRegisterPopup
                            }, index)
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full flex justify-between gap-4 flex-wrap max-w-screen-xl mx-auto px-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-left text-xs",
                            children: "*Fair Usage Policy Applicable"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-left text-xs",
                            children: "*SMS Credits have to be purchased separately"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-1 left-0 w-full [--swiper-pagination-color:black] [--swiper-pagination-bullet-width:14px] [--swiper-pagination-bullet-height:14px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "swiper-pagination"
                })
            }),
            showCalcomModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CalComModal/* default */.Z, {
                calLink: "boloforms/enterprise",
                close: ()=>setShowCalcomModal(false)
            }),
            imagePopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureImagePopup/* default */.Z, {
                image: imagePopup,
                close: ()=>setImagePopup(null)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignatureRegister/* default */.Z, {
                mode: "register",
                isPopupOpen: registerPopup,
                setIsPopupOpen: setRegisterPopup
            })
        ]
    });
};
/* harmony default export */ var Pricing_PricingTable2 = (PricingTable2);

// EXTERNAL MODULE: ./node_modules/react-icons/fa6/index.esm.js
var fa6_index_esm = __webpack_require__(70231);
// EXTERNAL MODULE: ./components/v2/Cards/GradientCheckIcon.jsx
var GradientCheckIcon = __webpack_require__(18495);
// EXTERNAL MODULE: ./components/v2/Pricing/ApiAddonPricingCard2.jsx + 1 modules
var ApiAddonPricingCard2 = __webpack_require__(26239);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var bs_index_esm = __webpack_require__(63750);
;// CONCATENATED MODULE: ./components/v2/Comparisons/PricingComparisions2.jsx










const PricingComparisons2 = (param)=>{
    let { monthly =false , showSwitch =true , heading ="Compare all the plans and choose the best one" , paragraph ="Our price comparison table is designed to help you save money and time, ensuring you always get the best value for your purchases." , paragraphStyling ="max-w-[550px] mx-auto" , stickyMargin ="lg:top-[112px]"  } = param;
    var _pricingComparisonsData_features;
    const [isMonthly, setIsMonthly] = (0,react.useState)(monthly);
    const [imagePopup, setImagePopup] = (0,react.useState)(null);
    const [activePlanIndex, setActivePlanIndex] = (0,react.useState)(0);
    const changeTab = ()=>{
        setIsMonthly(!isMonthly);
    };
    const pricingComparisonsData = {
        plans: [
            {
                name: "Freelancer",
                price: {
                    symbol: "$",
                    amount: isMonthly ? "15" : "10",
                    duration: "/mo"
                },
                bgColor: "bg-[#f8e3f8]"
            },
            {
                name: "Team",
                price: {
                    symbol: "$",
                    amount: isMonthly ? "69" : "49",
                    duration: "/mo"
                },
                bgColor: "bg-[#b8f6b7]"
            },
            {
                name: "Growing Business",
                price: {
                    symbol: "$",
                    amount: isMonthly ? "129" : "99",
                    duration: "/mo"
                },
                bgColor: "bg-[#fee5cd]"
            }
        ],
        features: [
            {
                category: "Usage",
                items: [
                    {
                        name: "Number Of WorkSpaces",
                        values: [
                            "1 Default",
                            "1 Default",
                            "Unlimited & Free"
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/team-workspaces.png")
                    },
                    {
                        name: "Allowed Form Responses(Signature)",
                        values: [
                            "100 /month",
                            "500 /month",
                            "Unlimited"
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/forms.png")
                    },
                    {
                        name: "Number of PDFs",
                        values: [
                            "10 /month",
                            "Unlimited",
                            "Unlimited"
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/pdf.png")
                    },
                    {
                        name: "Number of Templates",
                        values: [
                            "10",
                            "Unlimited",
                            "Unlimited"
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/pdf-template.png")
                    },
                    {
                        name: "Number of Templates Responses",
                        values: [
                            "10",
                            "Unlimited",
                            "Unlimited"
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/pdf-template.png")
                    },
                    {
                        name: "Number of PDFs from Form Submissions",
                        values: [
                            "100",
                            "Unlimited",
                            "Unlimited"
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/generate-response-pdf.png")
                    }
                ]
            },
            {
                category: "Functionality",
                items: [
                    {
                        name: "Audit Log and History",
                        values: [
                            true,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/audit-trail.png")
                    },
                    {
                        name: "Signing Order",
                        values: [
                            true,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/signing-order.png")
                    },
                    {
                        name: "Form fields: drop-down, radio, etc.",
                        values: [
                            true,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/doc-editor.png")
                    },
                    {
                        name: "Notifications",
                        values: [
                            true,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/real-time-notifications.png")
                    },
                    {
                        name: "Form Branding",
                        values: [
                            true,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/form-branding.png")
                    },
                    {
                        name: "Send Generated PDFs",
                        values: [
                            true,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/individual-file-sharing.png")
                    },
                    {
                        name: "Structured Folder System",
                        values: [
                            true,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/create-files-folders.png")
                    },
                    {
                        name: "Custom PDF Name",
                        values: [
                            false,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-pdf-name.png")
                    },
                    {
                        name: "Form Analytics",
                        values: [
                            false,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/form-analytics.png")
                    },
                    {
                        name: "Custom WaterMark on Generated PDFs",
                        values: [
                            false,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/watermark.png")
                    },
                    {
                        name: "Bulk Send",
                        values: [
                            false,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/bulk-send.png")
                    },
                    {
                        name: "Bulk Generated PDF Download",
                        values: [
                            false,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/bulk-download.png")
                    },
                    {
                        name: "Admin Dashboard for User Management",
                        values: [
                            false,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-user-roles.png")
                    },
                    {
                        name: "Share Templates with Team Members",
                        values: [
                            false,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/team-workspaces.png")
                    },
                    {
                        name: "Signing via Shareable Link and QR Code",
                        values: [
                            false,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/generate-signing-link.png")
                    },
                    {
                        name: "Reminders",
                        values: [
                            false,
                            false,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/reminders.png")
                    },
                    {
                        name: "Workspaces",
                        values: [
                            false,
                            false,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/team-workspaces.png")
                    },
                    {
                        name: "Custom Email Branding",
                        values: [
                            false,
                            false,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/email-subject-body.png")
                    },
                    {
                        name: "Redirection URL in Forms",
                        values: [
                            false,
                            false,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-redirection-url.png")
                    },
                    {
                        name: "Redirection URL in PDFs",
                        values: [
                            false,
                            false,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-redirection-url.png")
                    },
                    {
                        name: "Password proctected PDFs",
                        values: [
                            false,
                            false,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/password-protection.png")
                    },
                    {
                        name: "Stripe",
                        values: [
                            false,
                            false,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/stripe-integration.png")
                    },
                    {
                        name: "Custom Development using our API",
                        values: [
                            "Contact Us",
                            "Contact Us",
                            "Contact Us"
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/api-integration.png")
                    }
                ]
            },
            {
                category: "Integrations",
                items: [
                    {
                        name: "Google Sheets Integration",
                        values: [
                            true,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/google-sheet.png")
                    },
                    {
                        name: "Google Contacts Integration",
                        values: [
                            false,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/import-contacts.png")
                    },
                    {
                        name: "Google Drive Integration",
                        values: [
                            false,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/google-drive.png")
                    },
                    {
                        name: "Pipedrive Integration",
                        values: [
                            false,
                            false,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/pipedrive.png")
                    },
                    // {
                    //   name: "Zapier Integration",
                    //   values: [false, false, true],
                    //   image: `${BASE_ASSETS_URL}/v2/ltd/features/zapier.png`,
                    // },
                    // {
                    //   name: "Pabbly Integration",
                    //   values: [false, false, true],
                    //   image: `${BASE_ASSETS_URL}/v2/ltd/features/pabbly.png`,
                    // },
                    {
                        name: "Dropbox Integration",
                        values: [
                            false,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/dropbox.png")
                    },
                    {
                        name: "Onedrive Integration",
                        values: [
                            false,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/onedrive.png")
                    },
                    {
                        name: "Highlevel Integration",
                        values: [
                            false,
                            false,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/highlevel.png")
                    },
                    // {
                    //   name: "Make Integration",
                    //   values: [false, false, true],
                    //   image: `${BASE_ASSETS_URL}/v2/ltd/features/make.png`,
                    // },
                    {
                        name: "Hubspot Integration",
                        values: [
                            false,
                            false,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/hubspot.png")
                    },
                    {
                        name: "Stripe Integration",
                        values: [
                            false,
                            false,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/stripe-integration.png")
                    }
                ]
            },
            {
                category: "Security",
                items: [
                    {
                        name: "HIPAA BAA",
                        values: [
                            "additonal 49$/mo",
                            "additonal 49$/mo",
                            "additonal 49$/mo"
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/hipaa-compliance.png")
                    }
                ]
            },
            {
                category: "Customer Support",
                items: [
                    {
                        name: "Support Reply within 2 Days",
                        values: [
                            true,
                            true,
                            true
                        ],
                        image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/chat-support.png")
                    }
                ]
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full relative max-w-screen-xl mx-auto px-4 md:px-12 mb-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-4xl md:text-6xl leading-snug mx-auto font-semibold text-center w-[85%] md:w-[70%]",
                        children: heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-5 w-[85%] md:w-[60%] mx-auto text-[18px] font-medium text-center",
                        children: paragraph || ""
                    }),
                    showSwitch && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-screen-xl mx-auto px-4 flex justify-center items-center space-x-4 md:pb-8 pt-8 pb-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inline-flex justify-center items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "md:text-xl text-sm  ".concat(isMonthly ? "bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent font-bold" : "text-gray-500 font-semibold"),
                                        children: "Monthly"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: changeTab,
                                        className: "relative w-12 h-8 bg-gray-300 rounded-full p-1 transition-colors duration-300",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(proxy/* motion.div */.E.div, {
                                            layout: true,
                                            className: "w-6 h-6 bg-white rounded-full shadow-md",
                                            animate: {
                                                x: isMonthly ? 0 : 16
                                            },
                                            transition: {
                                                type: "spring",
                                                stiffness: 400,
                                                damping: 30
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "md:text-xl text-sm  ".concat(!isMonthly ? "bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent font-bold" : "text-gray-500 font-semibold"),
                                        children: [
                                            "Annually",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "inline-flex justify-center items-center px-4 py-2 ml-2 bg-gray-100 rounded-md",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "bg-purple/10 md:text-base text-xs bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent font-semibold",
                                                    children: "Upto 40% Off"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " w-full max-w-screen-txl mx-auto flex flex-col px-4 lg:px-8 overflow-x-scroll lg:overflow-x-visible scrollbar-corner-white scrollbar-thin scrollbar-thumb-slate-500 scrollbar-track-slate-200",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-full w-[1024px] lg:w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full lg:grid hidden grid-cols-5 lg:sticky top-20 gap-4 py-3 ".concat(stickyMargin, " bg-white"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-span-2 p-4 flex items-start justify-center text-4xl font-semibold flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-4xl font-semibold text-left",
                                            children: "Features"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base text-gray-600 mt-2 max-w-2xl text-left",
                                            children: "Compare what's included in each plan — from basic essentials to advanced tools for growing teams. Choose the right features for your needs."
                                        })
                                    ]
                                }),
                                pricingComparisonsData.plans.map((plan, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-span-1 p-4 text-center flex flex-col gap-2 bg-surface rounded-xl",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "text-2xl font-semibold",
                                                children: plan.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex justify-center items-end",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-4xl font-bold",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-2xl mr-1",
                                                                children: plan.price.symbol
                                                            }),
                                                            plan.price.amount
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-xl",
                                                        children: plan.price.duration
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-center text-sm text-gray-600",
                                                children: isMonthly ? "Billed monthly" : "Billed Annually"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "",
                                                className: "border border-gray-800 hover:bg-gray-200 py-1 mt-4 rounded-md transition-all duration-500 ease-in-out ",
                                                children: "Subscribe"
                                            })
                                        ]
                                    }, index);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative bg-white border-b lg:hidden justify-between px-4 mb-4 w-full max-w-2xl mx-auto flex",
                            children: pricingComparisonsData.plans.map((plan, index)=>{
                                const isActive = index === activePlanIndex;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: ()=>setActivePlanIndex(index),
                                    className: "relative flex flex-col items-center justify-center text-sm text-gray-600 hover:text-black transition-all px-2 py-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "".concat(isActive ? "font-semibold" : "font-medium"),
                                            children: plan.name
                                        }),
                                        isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(proxy/* motion.div */.E.div, {
                                            layoutId: "underline",
                                            className: "absolute bottom-0 left-0 right-0 h-0.5 bg-gray-600 rounded-full",
                                            transition: {
                                                type: "spring",
                                                stiffness: 400,
                                                damping: 30
                                            }
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full box-border",
                            children: pricingComparisonsData === null || pricingComparisonsData === void 0 ? void 0 : (_pricingComparisonsData_features = pricingComparisonsData.features) === null || _pricingComparisonsData_features === void 0 ? void 0 : _pricingComparisonsData_features.map((feature, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-full lg:grid hidden grid-cols-5 gap-x-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-span-5 p-4 text-xl font-medium",
                                                    children: feature.category
                                                }),
                                                feature.items.map((item, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "group col-span-5 grid grid-cols-5 gap-4 text-sm sm:text-lg border-b border-slate-200",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-span-2 p-4 text-left  flex items-center group-hover:bg-surface-light/50 ".concat((item === null || item === void 0 ? void 0 : item.image) ? "underline underline-offset-2 decoration-dotted cursor-pointer" : ""),
                                                                onClick: ()=>{
                                                                    return setImagePopup(item === null || item === void 0 ? void 0 : item.image);
                                                                },
                                                                children: item.name
                                                            }),
                                                            item.values.map((value, index)=>{
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-span-1 p-4 text-center flex justify-center items-center bg-surface-light/50 group-hover:bg-surface-light",
                                                                    children: value === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(bs_index_esm/* BsCheckCircleFill */.N9r, {
                                                                        className: "text-xl text-accent-purple"
                                                                    }) : value === false ? "" : value
                                                                }, index);
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            ]
                                        }, index),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "lg:hidden w-full",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-xl font-medium px-4 py-2 text-left",
                                                    children: feature.category
                                                }),
                                                feature.items.map((item, itemIndex)=>{
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                        className: "border-b border-slate-200 px-4 py-3 flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-sm ".concat((item === null || item === void 0 ? void 0 : item.image) ? "underline underline-offset-2 decoration-dotted cursor-pointer" : ""),
                                                                onClick: ()=>{
                                                                    return (item === null || item === void 0 ? void 0 : item.image) && setImagePopup(item.image);
                                                                },
                                                                children: item.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-sm text-right",
                                                                children: item.values[activePlanIndex] === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(bs_index_esm/* BsCheckCircleFill */.N9r, {
                                                                    className: "text-accent-purple text-lg"
                                                                }) : item.values[activePlanIndex] === false ? "" : item.values[activePlanIndex]
                                                            })
                                                        ]
                                                    }, itemIndex);
                                                })
                                            ]
                                        })
                                    ]
                                });
                            })
                        })
                    ]
                })
            }),
            imagePopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureImagePopup/* default */.Z, {
                image: imagePopup,
                close: ()=>setImagePopup(null)
            })
        ]
    });
};
/* harmony default export */ var PricingComparisions2 = (PricingComparisons2);

// EXTERNAL MODULE: ./components/v2/Cards/PricingCardsV2.jsx
var PricingCardsV2 = __webpack_require__(79578);
// EXTERNAL MODULE: ./components/customers/AnimatedLogos.jsx
var AnimatedLogos = __webpack_require__(7434);
// EXTERNAL MODULE: ./components/request-demo/index.jsx
var request_demo = __webpack_require__(45248);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/CLM/PricingCardsCLM/index.jsx




const PricingCardsCLM = ()=>{
    const router = useRouter();
    const annualPlan = {
        name: "Annual Plan",
        price: "$499",
        period: "month",
        billedAs: "billed as $6000/year",
        popular: true,
        features: {
            core: {
                documents: "Unlimited",
                forms: "Unlimited",
                template: "Unlimited"
            },
            clmTools: [
                "Smart Contract Editor",
                "Approval Workflows",
                "Renewal Reminders",
                "Clause Library",
                "Version History & Change Logs",
                "Clickwrap & Policy hosting",
                "and more..."
            ],
            signatureFeatures: [
                "Legally binding eSignatures",
                "OTP & Password Protection",
                "Bulk Send",
                "Bulk Download",
                "and more..."
            ],
            aiTools: [
                "Certius AI",
                "AI Drafting & Redlining",
                "Clause Suggestions",
                "Risk Flagging"
            ],
            other: [
                "One-Click Migration from other platforms like DocuSign",
                "Google Drive, Dropbox, Hubspot, Pipedrive, GoHighLevel and other CRM integrations",
                "Stripe integration",
                "Unlimited Members",
                "Folder Permissions",
                "Workspace Collaboration",
                "Priority Support",
                "Personal Onboarding Assistance",
                "Custom feature requests development",
                "Help Center & Chat",
                "Audit Trail",
                "Certificate of Completion",
                "Role-based Access",
                "White-labeled Emails & URLs",
                "Logos and themes",
                "and more..."
            ]
        }
    };
    const quarterlyPlan = {
        name: "Quarterly Plan",
        price: "$699",
        period: "quarter",
        billedAs: "billed quarterly",
        popular: false,
        features: {
            core: {
                documents: "Unlimited",
                forms: "Unlimited",
                template: "Unlimited"
            },
            included: [
                "CLM Tools",
                "Signature Features",
                "AI Tools",
                "Easy Migration",
                "Integrations",
                "Team Access",
                "Support",
                "Audit & Security",
                "Custom Branding"
            ]
        }
    };
    const FeatureList = (param)=>/*#__PURE__*/ {
        let { features , title  } = param;
        return _jsxs("div", {
            className: "mb-6",
            children: [
                /*#__PURE__*/ _jsx("h4", {
                    className: "text-sm font-semibold text-gray-700 mb-3",
                    children: title
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "space-y-2",
                    children: features.map((feature, index)=>/*#__PURE__*/ _jsxs("div", {
                            className: "flex items-start",
                            children: [
                                /*#__PURE__*/ _jsx(Check, {
                                    className: "w-4 h-4 text-green-500 mr-3 mt-0.5 flex-shrink-0"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-sm text-gray-600 text-left",
                                    children: feature
                                })
                            ]
                        }, index))
                })
            ]
        });
    };
    const CoreFeatures = (param)=>/*#__PURE__*/ {
        let { core  } = param;
        return _jsxs("div", {
            className: "mb-6",
            children: [
                /*#__PURE__*/ _jsx("h4", {
                    className: "text-sm font-semibold text-gray-700 mb-3",
                    children: "Core Features"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "space-y-2",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-sm text-gray-600",
                                    children: "Documents"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-sm font-medium text-gray-900",
                                    children: core.documents
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-sm text-gray-600",
                                    children: "Forms"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-sm font-medium text-gray-900",
                                    children: core.forms
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-sm text-gray-600",
                                    children: "Templates"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-sm font-medium text-gray-900",
                                    children: core.template
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "min-h-screen px-4 pb-12",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "max-w-7xl mx-auto",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "grid lg:grid-cols-2 gap-8 max-w-5xl mx-auto",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "relative bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden",
                            children: [
                                annualPlan.popular && /*#__PURE__*/ _jsx("div", {
                                    className: "absolute top-0 right-0 bg-gradient-to-r from-blue-500 to-purple-600 text-white px-4 py-2 rounded-bl-lg",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-center space-x-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Star, {
                                                className: "w-4 h-4"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-sm font-medium",
                                                children: "Most Popular"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "p-8",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "text-center mb-8",
                                            children: [
                                                /*#__PURE__*/ _jsx("h3", {
                                                    className: "text-2xl font-bold text-gray-900 mb-2",
                                                    children: annualPlan.name
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "flex items-baseline justify-center mb-2",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "text-5xl font-bold text-gray-900",
                                                            children: annualPlan.price
                                                        }),
                                                        /*#__PURE__*/ _jsxs("span", {
                                                            className: "text-xl text-gray-600 ml-2",
                                                            children: [
                                                                "/",
                                                                annualPlan.period
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("p", {
                                                    className: "text-sm text-gray-500",
                                                    children: annualPlan.billedAs
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("button", {
                                            onClick: ()=>router.push("/clm/request-demo"),
                                            className: "w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white font-semibold py-3 px-6 rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-200 transform hover:scale-105 mb-8",
                                            children: "Book a Demo"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "space-y-6",
                                            children: [
                                                /*#__PURE__*/ _jsx(CoreFeatures, {
                                                    core: annualPlan.features.core
                                                }),
                                                /*#__PURE__*/ _jsx(FeatureList, {
                                                    features: annualPlan.features.clmTools,
                                                    title: "CLM Tools"
                                                }),
                                                /*#__PURE__*/ _jsx(FeatureList, {
                                                    features: annualPlan.features.signatureFeatures,
                                                    title: "Signature Features"
                                                }),
                                                /*#__PURE__*/ _jsx(FeatureList, {
                                                    features: annualPlan.features.aiTools,
                                                    title: "AI Tools"
                                                }),
                                                /*#__PURE__*/ _jsx(FeatureList, {
                                                    features: annualPlan.features.other,
                                                    title: "Additional Features"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-col gap-6",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "p-8",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "text-center mb-8",
                                                children: [
                                                    /*#__PURE__*/ _jsx("h3", {
                                                        className: "text-2xl font-bold text-gray-900 mb-2",
                                                        children: quarterlyPlan.name
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex items-baseline justify-center mb-2",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "text-5xl font-bold text-gray-900",
                                                                children: quarterlyPlan.price
                                                            }),
                                                            /*#__PURE__*/ _jsxs("span", {
                                                                className: "text-xl text-gray-600 ml-2",
                                                                children: [
                                                                    "/",
                                                                    quarterlyPlan.period
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        className: "text-sm text-gray-500",
                                                        children: quarterlyPlan.billedAs
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("button", {
                                                onClick: ()=>router.push("/clm/request-demo"),
                                                className: "w-full bg-gray-900 text-white font-semibold py-3 px-6 rounded-lg hover:bg-gray-800 transition-all duration-200 transform hover:scale-105 mb-8",
                                                children: "Book a Demo"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "space-y-6",
                                                children: [
                                                    /*#__PURE__*/ _jsx(CoreFeatures, {
                                                        core: quarterlyPlan.features.core
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "bg-gradient-to-r from-green-50 to-blue-50 rounded-lg p-6 border border-green-200",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "flex items-center mb-4",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Zap, {
                                                                        className: "w-5 h-5 text-green-600 mr-2"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("h4", {
                                                                        className: "text-lg font-semibold text-gray-900",
                                                                        children: "Everything Included"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx("p", {
                                                                className: "text-sm text-gray-600 mb-4",
                                                                children: "Get access to all premium features available in the annual plan"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "grid grid-cols-2 gap-2",
                                                                children: quarterlyPlan.features.included.map((feature, index)=>/*#__PURE__*/ _jsxs("div", {
                                                                        className: "flex items-center",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Check, {
                                                                                className: "w-4 h-4 text-green-500 mr-2 flex-shrink-0"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-sm text-gray-700",
                                                                                children: feature
                                                                            })
                                                                        ]
                                                                    }, index))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "bg-yellow-50 border border-yellow-200 rounded-lg p-4",
                                                        children: /*#__PURE__*/ _jsxs("p", {
                                                            className: "text-sm text-yellow-800",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("strong", {
                                                                    children: "Note:"
                                                                }),
                                                                " All features from the Annual Plan are included in the Quarterly Plan with the same functionality and unlimited usage."
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "bg-white rounded-2xl shadow-sm border border-gray-200 p-8",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "text-center mb-8",
                                            children: [
                                                /*#__PURE__*/ _jsx("h2", {
                                                    className: "text-3xl font-bold text-gray-900 mb-4",
                                                    children: "Enterprise Security & Compliance"
                                                }),
                                                /*#__PURE__*/ _jsx("p", {
                                                    className: "text-lg text-gray-600",
                                                    children: "Trusted by 10,000+ Businesses Worldwide"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "grid gap-8",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-200",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "flex items-center mb-4",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4",
                                                                    children: /*#__PURE__*/ _jsx("svg", {
                                                                        className: "w-6 h-6 text-blue-600",
                                                                        fill: "none",
                                                                        stroke: "currentColor",
                                                                        viewBox: "0 0 24 24",
                                                                        children: /*#__PURE__*/ _jsx("path", {
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round",
                                                                            strokeWidth: 2,
                                                                            d: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("h3", {
                                                                    className: "text-xl font-semibold text-gray-900",
                                                                    children: "Single Sign-On (SSO)"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "space-y-2",
                                                            children: [
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "flex items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Check, {
                                                                            className: "w-4 h-4 text-green-500 mr-2"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "text-sm text-gray-600",
                                                                            children: "Seamless user authentication"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "flex items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Check, {
                                                                            className: "w-4 h-4 text-green-500 mr-2"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "text-sm text-gray-600",
                                                                            children: "Centralized access management"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "flex items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Check, {
                                                                            className: "w-4 h-4 text-green-500 mr-2"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "text-sm text-gray-600",
                                                                            children: "Reduced password fatigue"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-6 border border-green-200",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "flex items-center mb-4",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4",
                                                                    children: /*#__PURE__*/ _jsx("svg", {
                                                                        className: "w-6 h-6 text-green-600",
                                                                        fill: "none",
                                                                        stroke: "currentColor",
                                                                        viewBox: "0 0 24 24",
                                                                        children: /*#__PURE__*/ _jsx("path", {
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round",
                                                                            strokeWidth: 2,
                                                                            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("h3", {
                                                                    className: "text-xl font-semibold text-gray-900",
                                                                    children: "Compliance Ready"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "space-y-2",
                                                            children: [
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "flex items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Check, {
                                                                            className: "w-4 h-4 text-green-500 mr-2"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "text-sm text-gray-600",
                                                                            children: "SOC 2 Type II compliant"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "flex items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Check, {
                                                                            className: "w-4 h-4 text-green-500 mr-2"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "text-sm text-gray-600",
                                                                            children: "SOC 2 certified"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "flex items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Check, {
                                                                            className: "w-4 h-4 text-green-500 mr-2"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "text-sm text-gray-600",
                                                                            children: "ISO 27001 GDPR compliant"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "mt-12 text-center",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "text-gray-600 mb-4",
                            children: "Need help choosing the right plan?"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            onClick: ()=>router.push("/clm/request-demo"),
                            className: "text-blue-600 hover:text-blue-700 font-medium",
                            children: "Contact our sales team"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CLM_PricingCardsCLM = ((/* unused pure expression or super */ null && (PricingCardsCLM)));

;// CONCATENATED MODULE: ./pages/signature/pricing/index.jsx


































const freeTrialData = {
    title: "Forever Free",
    description: "Start your digital journey with BoloSign.",
    price: 0,
    pricingType: "mo",
    pricingTag: 5,
    featuresIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
    bgColor: "bg-[#d7f3fe]",
    quantityName: "",
    recommended: false,
    additionalSeatPrice: 29,
    featuresTitle: "Key Features :",
    features: [
        {
            name: "Collect Signatures in Forms",
            image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/forms.png")
        },
        {
            name: "5 Form Submissions",
            image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/forms.png")
        },
        {
            name: "2 PDFs",
            image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/pdf.png")
        },
        {
            name: "2 Template Responses",
            image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/pdf-template.png")
        },
        {
            name: "5 Signature Forms",
            image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/forms.png")
        },
        {
            name: "Audit Log and History",
            image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/audit-trail.png")
        },
        {
            name: "Structured Folder System",
            image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/create-files-folders.png")
        },
        {
            name: "Signing Order",
            image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/signing-order.png")
        },
        {
            name: "Certification of completion & electronic record disclosure",
            image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/ueta.png")
        },
        {
            name: "Form fields: drop-down, radio, checkbox, matrix, etc.",
            image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/doc-editor.png")
        },
        {
            name: "Secure completed contracts with tamper-proof trust seal"
        }
    ],
    pricingLink: "#"
};
const monthlyPricing = [
    // {
    //   title: "Forever Free",
    //   description: "Start your digital journey with BoloSign.",
    //   price: 0,
    //   pricingType: "mo",
    //   pricingTag: 5,
    //   featuresIcon: <MdStars />,
    //   bgColor: "bg-[#d7f3fe]",
    //   quantityName: "",
    //   recommended: false,
    //   transparent: true,
    //   additionalSeatPrice: 29,
    //   featuresTitle: "Key Features :",
    //   features: [
    //     {
    //       name: "Collect Signatures in Forms",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
    //     },
    //     {
    //       name: "5 Form Submissions",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
    //     },
    //     {
    //       name: "2 PDFs",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf.png`,
    //     },
    //     {
    //       name: "2 Template Responses",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf-template.png`,
    //     },
    //     {
    //       name: "5 Signature Forms",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
    //     },
    //     {
    //       name: "Audit Log and History",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/audit-trail.png`,
    //     },
    //     {
    //       name: "Structured Folder System",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/create-files-folders.png`,
    //     },
    //     {
    //       name: "Signing Order",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/signing-order.png`,
    //     },
    //     {
    //       name: "Certification of completion & electronic record disclosure",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/ueta.png`,
    //     },
    //     {
    //       name: "Form fields: drop-down, radio, checkbox, matrix, etc.",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/doc-editor.png`,
    //     },
    //   ],
    //   pricingLink: "#",
    // },
    {
        title: "Freelancer",
        description: "For people just looking to take signatures in Forms.",
        price: 15,
        pricingType: "mo",
        pricingTag: 100,
        featuresIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
        bgColor: "bg-[#f8e3f8]",
        quantityName: "Pack",
        recommended: false,
        additionalSeatPrice: 29,
        featuresTitle: 'Everything in <a href="#bolosign-free-plan" class="underline">Free Plan</a>, plus :',
        features: [
            {
                name: "100 Form Submissions",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/forms.png")
            },
            {
                name: "10 PDFs",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/pdf.png")
            },
            {
                name: "10 Template Responses",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/pdf-template.png")
            },
            {
                name: "10 Signature Forms",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/forms.png")
            },
            {
                name: "Form Branding",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/form-branding.png")
            },
            {
                name: "Send A Copy of Generated PDFs",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/generate-response-pdf.png")
            },
            {
                name: "PDF Link for sharing",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/generate-signing-link.png")
            },
            {
                name: "Secure completed contracts with tamper-proof trust seal"
            }
        ],
        pricingLink: "#"
    },
    {
        title: "Team",
        description: "For people who want a one-stop solution to take signatures in Form and PDF.",
        price: 69,
        pricingType: "mo",
        pricingTag: 500,
        featuresIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
        bgColor: "bg-[#b8f6b7]",
        quantityName: "Pack",
        recommended: true,
        additionalSeatPrice: 29,
        featuresTitle: "Everything in Freelancer, plus :",
        features: [
            {
                name: "500 Form Submissions",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/forms.png")
            },
            {
                name: "Unlimited Members*",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/members.png")
            },
            {
                name: "Unlimited PDFs*",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/pdf.png")
            },
            {
                name: "Unlimited Reusable Templates*",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/pdf-template.png")
            },
            {
                name: "Unlimited Signature Forms*",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/forms.png")
            },
            {
                name: "Form Analytics",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/form-analytics.png")
            },
            {
                name: "Import Fields",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/import-fields.png")
            },
            {
                name: "Admin Dashboard for User Management",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-user-roles.png")
            },
            {
                name: "Share Templates with Team Members",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/team-workspaces.png")
            },
            {
                name: "Custom Watermark in PDFs",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/watermark.png")
            },
            {
                name: "Google Drive Integration",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/google-drive.png")
            },
            {
                name: "Custom PDF Name Generation",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-pdf-name.png")
            },
            {
                name: "Bulk Download",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/bulk-download.png")
            },
            {
                name: "Bulk Send",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/bulk-send.png")
            },
            {
                name: "PDF Variables",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/variables.png")
            },
            {
                name: "Dropbox and OneDrive integrations",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/dropbox-onedrive.png")
            },
            {
                name: "Secure completed contracts with tamper-proof trust seal"
            }
        ],
        pricingLink: "#"
    },
    {
        title: "Growing Business",
        description: "Designed for businesses experiencing growth and expansion.",
        price: 129,
        pricingType: "mo",
        pricingTag: "Unlimited",
        featuresIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
        bgColor: "bg-[#fee5cd]",
        // quantityName: "Workspace",
        recommended: false,
        additionalSeatPrice: 29,
        featuresTitle: "Everything in Team, plus :",
        features: [
            {
                name: "Unlimited Form Submissions*",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/forms.png")
            },
            {
                name: "Unlimited Workspaces",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/team-workspaces.png")
            },
            {
                name: "Redirection URL in Forms",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-redirection-url.png")
            },
            {
                name: "Redirection URL in PDFs",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-redirection-url.png")
            },
            {
                name: "Email Branding",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/email-subject-body.png")
            },
            {
                name: "Read Receipts",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/audit-trail.png")
            },
            {
                name: "Password proctected PDFs",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/password-protection.png")
            },
            {
                name: "Stripe",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/stripe-integration.png")
            },
            // {
            //   name: "Hubspot, Pipedrive, GoHighLevel integrations",
            //   image: `${BASE_ASSETS_URL}/v2/ltd/features/crm-integrations.png`,
            // },
            {
                name: "Create Custom Data Fields",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-data-fields.png")
            },
            {
                name: "Custom Email",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-email.png")
            },
            {
                name: "Custom Email Subject & Email Body",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/email-subject-body.png")
            },
            {
                name: "Customize Form URLs",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-url.png")
            },
            {
                name: "Access Code Verification",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/access-code-verification.png")
            },
            // {
            //   name: "Approval Workflow",
            //   image: `${BASE_ASSETS_URL}/v2/ltd/features/approval-workflow.png`,
            // },
            {
                name: "Secure completed contracts with tamper-proof trust seal"
            }
        ],
        pricingLink: "#"
    },
    {
        title: "Enterprise",
        description: "For large enterprises demanding top-tier solutions.",
        price: "Get tailored pricing for high-volume document needs and seats",
        pricingType: "mo",
        pricingTag: "Unlimited",
        featuresIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdStars */.gms, {}),
        bgColor: "bg-[#d7f3fe]",
        buttonText: "Book A Demo",
        transparent: false,
        recommended: false,
        featuresTitle: "Everything in Business, plus :",
        features: [
            {
                name: "Enhance security with single sign-on (SSO)"
            },
            {
                name: "Bulk send individual requests to a large list of signers"
            },
            {
                name: "Hubspot, Pipedrive, GoHighLevel and other CRM integrations",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/crm-integrations.png")
            },
            {
                name: "Approval Workflow",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/approval-workflow.png")
            },
            {
                name: "Custom feature requests development"
            },
            {
                name: "Receive assisted onboarding from a dedicated Success Manager"
            },
            {
                name: "Secure completed contracts with tamper-proof trust seal"
            },
            {
                name: "Import from Docusign"
            }
        ]
    }
];
const yearlyPricing = [
    // {
    //   title: "Forever Free",
    //   description: "Start your digital journey with BoloSign.",
    //   price: 0,
    //   pricingType: "yr",
    //   pricingTag: 5,
    //   featuresIcon: <MdStars />,
    //   bgColor: "bg-[#d7f3fe]",
    //   quantityName: "",
    //   recommended: false,
    //   transparent: true,
    //   additionalSeatPrice: 29,
    //   featuresTitle: "Key Features :",
    //   features: [
    //     {
    //       name: "Collect Signatures in Forms",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
    //     },
    //     {
    //       name: "5 Form Submissions",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
    //     },
    //     {
    //       name: "2 PDFs",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf.png`,
    //     },
    //     {
    //       name: "2 Template Responses",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/pdf-template.png`,
    //     },
    //     {
    //       name: "5 Signature Forms",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/forms.png`,
    //     },
    //     {
    //       name: "Audit Log and History",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/audit-trail.png`,
    //     },
    //     {
    //       name: "Structured Folder System",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/create-files-folders.png`,
    //     },
    //     {
    //       name: "Signing Order",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/signing-order.png`,
    //     },
    //     {
    //       name: "Certification of completion & electronic record disclosure",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/ueta.png`,
    //     },
    //     {
    //       name: "Form fields: drop-down, radio, checkbox, matrix, etc.",
    //       image: `${BASE_ASSETS_URL}/v2/ltd/features/doc-editor.png`,
    //     },
    //   ],
    //   pricingLink: "#",
    // },
    {
        title: "Freelancer",
        description: "For people just looking to take signatures in Forms.",
        price: 10,
        pricingType: "yr",
        pricingTag: 100,
        featuresIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
        bgColor: "bg-[#f8e3f8]",
        quantityName: "Pack",
        recommended: false,
        additionalSeatPrice: 29,
        featuresTitle: 'Everything in <a href="#bolosign-free-plan" class="underline">Free Plan</a>, plus :',
        features: [
            {
                name: "100 Form Submissions",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/forms.png")
            },
            {
                name: "10 PDFs",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/pdf.png")
            },
            {
                name: "10 Template Responses",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/pdf-template.png")
            },
            {
                name: "10 Signature Forms",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/forms.png")
            },
            {
                name: "Form Branding",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/form-branding.png")
            },
            {
                name: "Send A Copy of Generated PDFs",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/generate-response-pdf.png")
            },
            {
                name: "PDF Link for sharing",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/generate-signing-link.png")
            },
            {
                name: "Secure completed contracts with tamper-proof trust seal"
            }
        ],
        pricingLink: "#"
    },
    {
        title: "Team",
        description: "For people who want a one-stop solution to take signatures in Form and PDF.",
        price: 49,
        pricingType: "yr",
        pricingTag: 500,
        featuresIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
        bgColor: "bg-[#b8f6b7]",
        quantityName: "Pack",
        recommended: true,
        additionalSeatPrice: 29,
        featuresTitle: "Everything in Freelancer, plus :",
        features: [
            {
                name: "500 Form Submissions",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/forms.png")
            },
            {
                name: "Unlimited Members*",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/members.png")
            },
            {
                name: "Unlimited PDFs*",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/pdf.png")
            },
            {
                name: "Unlimited Reusable Templates*",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/pdf-template.png")
            },
            {
                name: "Unlimited Signature Forms*",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/forms.png")
            },
            {
                name: "Form Analytics",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/form-analytics.png")
            },
            {
                name: "Import Fields",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/import-fields.png")
            },
            {
                name: "Admin Dashboard for User Management",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-user-roles.png")
            },
            {
                name: "Share Templates with Team Members",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/team-workspaces.png")
            },
            {
                name: "Custom Watermark in PDFs",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/watermark.png")
            },
            {
                name: "Google Drive Integration",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/google-drive.png")
            },
            {
                name: "Custom PDF Name Generation",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-pdf-name.png")
            },
            {
                name: "Bulk Download",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/bulk-download.png")
            },
            {
                name: "Bulk Send",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/bulk-send.png")
            },
            {
                name: "PDF Variables",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/variables.png")
            },
            {
                name: "Dropbox and OneDrive integrations",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/dropbox-onedrive.png")
            },
            {
                name: "Secure completed contracts with tamper-proof trust seal"
            }
        ],
        pricingLink: "#"
    },
    {
        title: "Growing Business",
        description: "Designed for businesses experiencing growth and expansion.",
        price: 99,
        pricingType: "yr",
        pricingTag: "Unlimited",
        featuresIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
        bgColor: "bg-[#fee5cd]",
        // quantityName: "Workspace",
        recommended: false,
        additionalSeatPrice: 29,
        featuresTitle: "Everything in Team, plus :",
        features: [
            {
                name: "Unlimited Form Submissions*",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/forms.png")
            },
            {
                name: "Unlimited Workspaces",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/team-workspaces.png")
            },
            {
                name: "Redirection URL in Forms",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-redirection-url.png")
            },
            {
                name: "Redirection URL in PDFs",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-redirection-url.png")
            },
            {
                name: "Email Branding",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/email-subject-body.png")
            },
            {
                name: "Read Receipts",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/audit-trail.png")
            },
            {
                name: "Password proctected PDFs",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/password-protection.png")
            },
            {
                name: "Stripe",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/stripe-integration.png")
            },
            // {
            //   name: "Hubspot, Pipedrive, GoHighLevel integrations",
            //   image: `${BASE_ASSETS_URL}/v2/ltd/features/crm-integrations.png`,
            // },
            {
                name: "Create Custom Data Fields",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-data-fields.png")
            },
            {
                name: "Custom Email",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-email.png")
            },
            {
                name: "Custom Email Subject & Email Body",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/email-subject-body.png")
            },
            {
                name: "Customize Form URLs",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/custom-url.png")
            },
            {
                name: "Access Code Verification",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/access-code-verification.png")
            },
            {
                name: "Reminders",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/reminders.png")
            },
            // {
            //   name: "Approval Workflow",
            //   image: `${BASE_ASSETS_URL}/v2/ltd/features/approval-workflow.png`,
            // },
            {
                name: "Secure completed contracts with tamper-proof trust seal"
            }
        ],
        pricingLink: "#"
    },
    {
        title: "Enterprise",
        description: "For large enterprises demanding top-tier solutions.",
        price: "Get tailored pricing for high-volume document needs and seats",
        pricingType: "mo",
        pricingTag: "Unlimited",
        featuresIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa6_index_esm/* FaRegCircleCheck */.ReY, {}),
        bgColor: "bg-[#d7f3fe]",
        buttonText: "Book A Demo",
        transparent: false,
        recommended: false,
        featuresTitle: "Everything in Business, plus :",
        features: [
            {
                name: "Enhance security with single sign-on (SSO)"
            },
            {
                name: "Bulk send individual requests to a large list of signers"
            },
            {
                name: "Hubspot, Pipedrive, GoHighLevel and other CRM integrations",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/crm-integrations.png")
            },
            {
                name: "Approval Workflow",
                image: "".concat(constants.BASE_ASSETS_URL, "/v2/ltd/features/approval-workflow.png")
            },
            {
                name: "Custom feature requests development"
            },
            {
                name: "Receive assisted onboarding from a dedicated Success Manager"
            },
            {
                name: "Secure completed contracts with tamper-proof trust seal"
            },
            {
                name: "Import from Docusign"
            }
        ]
    }
];
const companyLogos = [
    {
        url: "".concat(constants.BASE_ASSETS_URL, "/case-studies/angelfire.png"),
        name: "Angelfire",
        haveCaseStudy: true,
        companyKey: "angel-fire".toLowerCase()
    },
    {
        url: "".concat(constants.BASE_ASSETS_URL, "/case-studies/transport.png"),
        name: "G & H Transport",
        haveCaseStudy: true,
        companyKey: "g-h-transport".toLowerCase()
    },
    {
        url: "".concat(constants.BASE_ASSETS_URL, "/case-studies/beaver.png"),
        name: "Beaver",
        haveCaseStudy: true,
        companyKey: "beaver".toLowerCase()
    },
    {
        url: "".concat(constants.BASE_ASSETS_URL, "/case-studies/shine-above.png"),
        name: "Shine Above",
        haveCaseStudy: true,
        companyKey: "shine-above".toLowerCase()
    },
    {
        url: "".concat(constants.BASE_ASSETS_URL, "/case-studies/harry-corry.png"),
        name: "Harry Corry",
        haveCaseStudy: true,
        companyKey: "harry-corry-ltd".toLowerCase()
    },
    {
        url: "".concat(constants.BASE_ASSETS_URL, "/case-studies/rethink.png"),
        name: "Rethink",
        haveCaseStudy: true,
        companyKey: "rethink".toLowerCase()
    },
    {
        url: "".concat(constants.BASE_ASSETS_URL, "/case-studies/mancosa.png"),
        name: "Mancosa",
        haveCaseStudy: true,
        companyKey: "mancosa".toLowerCase()
    },
    {
        url: "".concat(constants.BASE_ASSETS_URL, "/case-studies/aging-comfort.png"),
        name: "Aging Comfort",
        haveCaseStudy: true,
        companyKey: "aging-comfort".toLowerCase()
    }
];
const apiMonthlyPricing = {
    title: "API",
    description: "Automate your signature workflow by integrating our API into your systems.",
    price: 20,
    pricingType: "mo",
    priceDetail: " + $0.2/document",
    featuresIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdStars */.gms, {}),
    recommended: false,
    features: [
        "100 Documents/mo Included",
        "$0.2 per Document Sent",
        "Can be purchased with any plan"
    ]
};
const apiYearlyPricing = {
    title: "API",
    description: "Automate your signature workflow by integrating our API into your systems.",
    price: 20,
    pricingType: "mo",
    priceDetail: " + $0.2/document",
    featuresIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdStars */.gms, {}),
    recommended: false,
    features: [
        "100 Documents/mo Included",
        "$0.2 per Document Sent",
        "Can be purchased with any plan"
    ]
};
const tabs = [
    {
        id: "1",
        name: "CLM"
    },
    // {
    //   id: "3",
    //   name: "eSignature",
    // },
    {
        id: "2",
        name: "API"
    }
];
const planType = (/* unused pure expression or super */ null && ([
    "Monthly",
    "Yearly"
]));
const Pricing = ()=>{
    const [activeTab, setActiveTab] = (0,react.useState)("CLM");
    const [imagePopup, setImagePopup] = (0,react.useState)(false);
    const [isMonthly, setIsMonthly] = (0,react.useState)(false);
    const changeTab = ()=>{
        setIsMonthly(!isMonthly);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative md:mt-20 mt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "BoloSign CLM Pricing | Best Pricing | Highest Security"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Explore BoloSign CLM pricing plans designed for businesses of all sizes. Enjoy competitive rates, top-tier security, and flexible options to streamline your contract lifecycle management."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "Boloforms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "publisher",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "BoloSign CLM pricing, contract lifecycle management pricing, CLM plans, eSignature pricing, document management pricing, business contract solutions, secure eSignature pricing"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/pricing/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "BoloSign CLM Pricing | Best Pricing | Highest Security"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/pricing/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "BoloSign CLM Pricing | Best Pricing | Highest Security"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/pricing/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto w-full flex flex-col text-center ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full relative max-w-screen-xl mx-auto px-4 md:px-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: "text-4xl md:text-6xl leading-snug mx-auto font-semibold",
                                        children: [
                                            "Request a Quote",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " for your business"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-5 w-[85%] md:w-[50%] mx-auto text-[18px] font-medium",
                                        children: "Schedule your personalized demo!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full mt-8 bg-white ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center items-center bg-gray-100 rounded-full p-2 w-fit mx-auto space-x-1 sm:space-x-2",
                                        children: tabs.map((tab)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                onClick: ()=>setActiveTab(tab.name),
                                                className: "relative z-10 px-6 py-2 text-sm sm:text-base rounded-full font-medium",
                                                children: [
                                                    activeTab === tab.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(proxy/* motion.div */.E.div, {
                                                        layoutId: "active-pill",
                                                        className: "absolute inset-0 z-0 bg-white rounded-full shadow-sm",
                                                        transition: {
                                                            type: "spring",
                                                            stiffness: 400,
                                                            damping: 30
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "relative z-10 ".concat(activeTab === tab.name ? "text-black" : "text-gray-500 hover:text-black"),
                                                        children: tab.name
                                                    })
                                                ]
                                            }, tab.id))
                                    }),
                                    activeTab === "eSignature" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "max-w-screen-xl mx-auto px-4 flex justify-center items-center space-x-4 md:pb-8 pt-8 pb-12",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "inline-flex justify-center items-center gap-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "md:text-xl text-sm  ".concat(isMonthly ? "bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent font-bold" : "text-gray-500 font-semibold"),
                                                                children: "Monthly"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                onClick: changeTab,
                                                                className: "relative w-12 h-8 bg-gray-300 rounded-full p-1 transition-colors duration-300",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(proxy/* motion.div */.E.div, {
                                                                    layout: true,
                                                                    className: "w-6 h-6 bg-white rounded-full shadow-md",
                                                                    animate: {
                                                                        x: isMonthly ? 0 : 16
                                                                    },
                                                                    transition: {
                                                                        type: "spring",
                                                                        stiffness: 400,
                                                                        damping: 30
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "md:text-xl text-sm  ".concat(!isMonthly ? "bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent font-bold" : "text-gray-500 font-semibold"),
                                                                children: [
                                                                    "Annually",
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "inline-flex justify-center items-center px-4 py-2 ml-2 bg-gray-100 rounded-md",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "bg-purple/10 md:text-base text-xs bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent font-semibold",
                                                                            children: "Upto 40% Off"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pricing_PricingTable2, {
                                                isMonthly: isMonthly,
                                                monthlyPricing: monthlyPricing,
                                                yearlyPricing: yearlyPricing
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                                id: "bolosign-free-plan",
                                                className: "w-full mb-20 sm:mb-24 px-4 md:px-8 mt-10",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-full max-w-screen-xl mx-auto",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FreePlanAccordion, {
                                                        setImagePopup: setImagePopup
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                id: "bolosign-pricing-comparison-table",
                                                className: "py-10",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingComparisions2, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "bg-surface-light pt-20 md:pb-20 pb-10 mx-auto px-4 md:px-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "max-w-screen-xl md:px-8 px-4 mx-auto flex flex-col sm:flex-row gap-14 sm:gap-8 lg:gap-16",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex-1 flex flex-col gap-16 sm:gap-8 lg:gap-14",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "h-full flex flex-col gap-2 text-lg items-start",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                            className: "text-5xl lg:text-6xl relative",
                                                                            children: "Add-Ons"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "text-left",
                                                                            children: "Get more out of your purchases with our valuable add-ons. Our selection includes a variety of features and services designed to provide additional benefits and convenience. Discover how you can unlock extra value and optimize your products with our add-ons."
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCard3, {
                                                                    title: "HIPAA",
                                                                    description: "Add security to your medical pratice by purchasing HIPAA bussiness associate agreement.",
                                                                    featuresIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
                                                                    features: [
                                                                        {
                                                                            name: "HIPAA BAA is Available on each plan as an Add-On"
                                                                        }
                                                                    ],
                                                                    price: 49,
                                                                    pricingType: "mo",
                                                                    cardBorder: true,
                                                                    bgColor: "bg-pink-100",
                                                                    buttonText: "Subscribe",
                                                                    buttonUrl: "https://buy.stripe.com/dR6aI1doC7892Pe7t4",
                                                                    transparent: false,
                                                                    isAnnualBilling: false
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "flex-1 flex flex-col gap-16 sm:gap-8 lg:gap-16",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCard3, {
                                                                title: "SMS",
                                                                description: "Send documents for signing via SMS for quick and easy e-signatures.",
                                                                featuresIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
                                                                features: [
                                                                    {
                                                                        name: "500 SMS Credits"
                                                                    },
                                                                    {
                                                                        name: "1 SMS Credit = 1 Send"
                                                                    },
                                                                    {
                                                                        name: "SMS is Available on each plan as an Add-On"
                                                                    }
                                                                ],
                                                                price: 12,
                                                                packagesCount: "/500 SMS Credits",
                                                                pricingType: "One-time",
                                                                cardBorder: true,
                                                                bgColor: "bg-lime-200",
                                                                buttonText: "Buy Now",
                                                                buttonUrl: "https://buy.stripe.com/28o2bvesG2RT2Pe3d8",
                                                                transparent: false,
                                                                isAnnualBilling: false
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full py-32 bg-dark",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "max-w-screen-xl mx-auto",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                            className: "text-3xl md:text-4xl leading-snug text-center mb-3 text-white font-semibold",
                                                            children: [
                                                                "5,000+ Companies ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                " Use BoloForms Around the World"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedLogos/* default */.Z, {})
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    activeTab === "API" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full max-w-screen-xl mx-auto pt-8 sm:pt-12 md:px-8 px-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApiAddonPricingCard2/* default */.Z, {
                                                    currentPage: "api"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full py-32 bg-dark",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "max-w-screen-xl mx-auto",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                            className: "text-3xl md:text-4xl leading-snug text-center mb-3 text-white font-semibold",
                                                            children: [
                                                                "5,000+ Companies ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                " Use BoloForms Around the World"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedLogos/* default */.Z, {})
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    activeTab === "CLM" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full pt-8 sm:pt-12 text-left ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(request_demo/* default */.Z, {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "bg-[#f4f2f0] text-black py-16 md:px-10 px-4 xl:px-20 text-center md:pt-24 pt-12 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ/* default */.Z, {})
                    })
                ]
            }),
            imagePopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureImagePopup/* default */.Z, {
                image: imagePopup,
                close: ()=>setImagePopup(null)
            })
        ]
    });
};
/* harmony default export */ var pricing = (Pricing);
const FreePlanAccordion = (param)=>{
    let { setImagePopup  } = param;
    const [isOpen, setIsOpen] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "border-2 border-slate-200 rounded-3xl lg:p-6 p-4 sm:px-8 sm:py-6 w-full bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full flex flex-wrap gap-4 justify-between items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-4xl font-bold text-left",
                                children: "Free Plan"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-base text-left text-gray-600 mt-4 min-h-[60px] ",
                                children: "For individuals seeking the quickest way to sign or send a contract for signature."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex gap-4 text-xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_Buttons/* CLMButtonPrimary */.IS, {
                            buttonUrl: "https://signature.boloforms.com/register?from=PRICING_PAGE".concat((0,signature_owner/* createUTMQueryParams */.T0)({
                                from: "PRICING_PAGE"
                            })),
                            buttonText: "Try Now For Free"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-t-2 border-slate-200 mt-8 pt-6 pb-4 ".concat(isOpen ? "block" : "block md:hidden"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid sm:grid-cols-2 gap-4",
                    children: freeTrialData === null || freeTrialData === void 0 ? void 0 : freeTrialData.features.map((feature, index)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-start justify-start gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " w-6 h-6 flex items-center justify-center shrink-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-base leading-[24px] font-medium hover:bg-gradient-to-r text-left   ".concat((feature === null || feature === void 0 ? void 0 : feature.image) ? " underline underline-offset-[5px] decoration-dotted cursor-pointer decoration-gray-400 hover:decoration-primary hover:text-primary hover:from-purple-500  hover:via-indigo-500  hover:to-blue-500  hover:bg-clip-text  hover:text-transparent " : ""),
                                    onClick: ()=>{
                                        return (feature === null || feature === void 0 ? void 0 : feature.image) && setImagePopup(feature.image);
                                    },
                                    children: feature === null || feature === void 0 ? void 0 : feature.name
                                })
                            ]
                        }, index);
                    })
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,1057,7627,5937,8885,8254,8041,5991,3103,273,7225,5248,9774,2888,179], function() { return __webpack_exec__(49707); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);